import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import MainLayout from "./containers/MainLayout/new";
import AuthLayout from "./containers/Authentication/layout";
import AppsComponent from "./containers/Apps";
import { useAppDispatch, useAppSelector } from "./store";
import Login from "./containers/Authentication/Login";
import Signup from "./containers/Authentication/Signup";
import Hotel from "./containers/Hotel";
import Flight from "./containers/Flight";
import { useTopic } from "./context/topicContext";
import { useNewChat } from "./context/newChatContext";
import Merchant from "./containers/Merchant";
import VerificationCode from "./containers/Authentication/VerifyCode";
import Booking from "./containers/Booking";
import ProfilePage from "./containers/Profile";
import Terms from "./containers/Terms";
import ForgotPasswordPage from "./containers/Authentication/ForgotPassword";
import Social from "./containers/Social";
import Chat from "./containers/Chat";
import { getUserInfoThunk } from "./store/actions/auth.action";
import PostDetail from "./containers/PostDetail";
import SocialLayout from "./containers/Social/Layout";
import Companies from "./containers/Companies";
import NotificationAdmin from "./containers/NotificationAdmin";

export default function App() {
  const authState = useAppSelector((state) => state.authReducer);
  const { setTopic } = useTopic();
  const { setIsNewChat } = useNewChat();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const fetchUserInfo = async () => {
    try {
      await dispatch(getUserInfoThunk());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const hasIdInUrl = pathParts.length > 2 && pathParts[2] !== "";
    const isValidRoute = ["/hotel", "/flight", "/merchant"].some((route) =>
      location.pathname.startsWith(route)
    );

    if (hasIdInUrl && isValidRoute) {
      setIsNewChat(false);
    } else {
      setIsNewChat(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const storedTopic = localStorage.getItem("topic");
    setTopic(storedTopic || "");
  }, [location.pathname]);

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <Routes>
      {!authState.me && (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/verify-code" element={<VerificationCode />} />
        </>
      )}
      <Route element={<MainLayout />}>
        <Route path="/chat/:id?" element={<Chat />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/terms-and-policies" element={<Terms />} />
        <Route element={<SocialLayout />}>
          <Route path="/" element={<Social />} />
          <Route path="/post/:id" element={<PostDetail />} />
        </Route>
      </Route>
      <Route element={<AuthLayout Layout={MainLayout} />}>
        <Route path="/hotel/:id?" element={<Hotel />} />
        <Route path="/flight/:id?" element={<Flight />} />
        <Route path="/merchant/:id?" element={<Merchant />} />
        <Route path="/profile" element={<ProfilePage />} />
        {authState.me?.isAdmin && (
          <>
            <Route path="/companies" element={<Companies />} />
            <Route path="/notification-admin" element={<NotificationAdmin />} />
          </>
        )}
        <Route element={<SocialLayout />}>
          <Route path="/" element={<Social />} />
          <Route path="/user/:id" element={<Social />} />
          <Route path="/post/:id" element={<PostDetail />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
